import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';

export const BANKRUPTCY_RISK_SCORE_COLOR = {
  very_low: 'green',
  low: 'green',
  medium: 'yellow',
  high: 'orange',
  very_high: 'red',
  unset: 'white',
} as const;

export const BANKRUPTCY_RISK_SCORE_TRANSLATIONS = {
  very_low: extractTranslation('watchlists.risk_chart.categories.very_low'),
  low: extractTranslation('watchlists.risk_chart.categories.low'),
  medium: extractTranslation('watchlists.risk_chart.categories.medium'),
  high: extractTranslation('watchlists.risk_chart.categories.high'),
  very_high: extractTranslation('watchlists.risk_chart.categories.very_high'),
} as const;
